import React, { useState } from 'react';
import axios from 'axios';

import * as XLSX from 'xlsx';

const SemResultUpdate = () => {
    const [excelFile, setExcelFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const overlayClass = `loading-overlay${loading ? ' visible' : ''}`;

    const handleFileChange = (event) => {
        setExcelFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        setLoading(true);
        try {
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    if (workbook.SheetNames.length === 0) {
                        console.error('No sheets found in the Excel file.');
                        return;
                    }
                    const sheetName = workbook.SheetNames[0];
                    const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    if (excelData.length === 0) {
                        console.error('No data found in the Excel sheet.');
                        return;
                    }
    
                    const batchSize = 1000; // Number of rows to process per batch
                    const totalRows = excelData.length;
                    let startIndex = 0;
    
                    while (startIndex < totalRows) {
                        const endIndex = Math.min(startIndex + batchSize, totalRows);
                        const batchData = excelData.slice(startIndex, endIndex);
    
                        // Process batch data
                        const semesterResultsToUpdate = {};
                        batchData.forEach((data) => {
                            const { registerNumber, coursecode, coursename, credit, result, grade, semester, DOB, studentName, degreeAndBranch, regulation } = data;
    
                            if (!semesterResultsToUpdate[registerNumber]) {
                                semesterResultsToUpdate[registerNumber] = [];
                            }
    
                            semesterResultsToUpdate[registerNumber].push({
                                semester,
                                code: coursecode,
                                name: coursename,
                                credit,
                                result,
                                grade,
                                DOB,
                                studentName,
                                regulation,
                                degreeAndBranch,
                            });
                        });
    
                        // Make a POST request to your server endpoint for each batch
                        const response = await axios.post('https://result-api-kiot.vercel.app/api/update_semester_results', { semesterResultsToUpdate });
    
                        console.log(response.data);
    
                        startIndex += batchSize;
                    }
    
                    setLoading(false);
                    setSuccessMessage("Students data uploaded successfully!");
                } catch (error) {
                    setLoading(false);
                    console.error('Error parsing Excel file:', error);
                }
            };
            reader.readAsArrayBuffer(excelFile);
        } catch (error) {
            setLoading(false);
            console.error('Error uploading semester results:', error);
        }
    };
    

    return (
        <div className="sem-result-update-container">
            <h1>Update Semester Results</h1>
            <div className='sem-result-update-specific-container'>
                <input className="file-input" type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
                <button className="upload-button" onClick={handleUpload}>
                    Upload
                </button>
            </div>
            {successMessage &&
                <div>{successMessage}</div>}
                <div>
                        {(loading) && <div className={overlayClass}>
                            <div className="spinner">
                                <img src="./uploads/loading-brand-logo.png" alt="loading-brand-logo" id="loading-brand-logo" />
                            </div>
                            <img src="./uploads/loading-brand-title.png" alt="loading-brand-title" id="loading-brand-title" />
                        </div>}
                    </div>
        </div>
    );
};

export default SemResultUpdate;
